import './Picture.scss';

function Picture() {
    return (
        <div className='picture'>
            <img alt="" src="/img/picture.png" loading="lazy" className='picture__img'/>
        </div>
    )
}
export default Picture;